import React, { useState, useEffect } from "react";
import classes from "./Optverify.module.css";
import promix from "../../Assets/Promix.svg";
import inbox from "../../Assets/inbox.svg";
import arrow from "../../Assets/arrow.svg";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { BASE_URL } from "../../Components/API/Api";

const Optverify = () => {
  const [otp, setOtp] = useState(["", "", "", "", "", "",]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [enteredOtp, setEnteredOtp] = useState("");
  const [email, setEmail] = useState("");

  useEffect(() => {
    const storedEmail = localStorage.getItem("email");
    if (!storedEmail) {
      Swal.fire("Error", "No email found. Please go back to forgot password.", "error");
      navigate("/forgotpassword");
    } else {
      setEmail(storedEmail);
    }
  }, [navigate]);


  const handleChange = (e, index) => {
    const value = e.target.value;
    if (/^\d?$/.test(value)) {
      const updatedOtp = [...otp];
      updatedOtp[index] = value;
      setOtp(updatedOtp);
      if (value && index < otp.length - 1) {
        document.getElementById(`otp-${index + 1}`).focus();
      }

    }
  };

  const handleSubmit = async () => {
    const enteredOtp = otp.join(""); // Join into a single string
    if (enteredOtp.length !== 6) {
      Swal.fire("Error", "Please enter a 6-digit OTP", "error");
      return;
    }

    setLoading(true);
    try {
      const res = await fetch(`${BASE_URL}/v1/verify_otp`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: email, // pass email if required
          otp: enteredOtp,
        }),
      });

      const data = await res.json();

      if (res.ok && (data.success || data.status)) {
        Swal.fire("Success", data.message || "OTP verified successfully!", "success");
        navigate("/newpassword");
      } else {
        Swal.fire("Error", data.message || "Invalid OTP", "error");
      }

    } catch (error) {
      Swal.fire("Error", "Something went wrong. Try again!", "error");
    } finally {
      setLoading(false);
    }
  };
  console.log("Email in storage:", email);
  console.log("OTP entered:", enteredOtp);



  return (
    <div className={classes.hoe}>
      <div className={classes.blink}>
        <div className={classes.put}>
          <img src={promix} alt="Promix" />
        </div>
        <div className={classes.cut}>
          <img src={inbox} alt="Inbox" />
        </div>
        <p className={classes.code}>Verify Your Account</p>
        <p className={classes.manin}>
          A 6-digit code has been sent to
          <span className={classes.pone}> {email}</span>
        </p>

        <div className={classes.verify}>
          {otp.map((digit, idx) => (
            <input
              key={idx}
              id={`otp-${idx}`}
              className={classes.pay_rt}
              value={digit}
              maxLength={1}
              onChange={(e) => handleChange(e, idx)}
            />
          ))}
        </div>

        <button
          className={classes.putty}
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading ? "Verifying..." : "Verify"}
        </button>

        <p className={classes.orter}>Didn't receive the code?</p>
        <p className={classes.crtuer}>Resend in 39s</p>

        <div className={classes.peter}>
          <img src={arrow} alt="Back" />
          <p className={classes.dart}>Back to Sign Up</p>
        </div>
      </div>
    </div>
  );
};

export default Optverify;
